export const environment = {
  production: false,
  apiUrl: 'https://ca-test.internal.sparbankensyd.se/api',
  authServiceUrl: 'https://ca-test.internal.sparbankensyd.se/service',
  domain: 'cert-app-stage.internal.sparbankensyd.se',
  testMode: true
}
